import { render, staticRenderFns } from "./LogisticsIntroduce.vue?vue&type=template&id=807d9718&scoped=true"
import script from "./LogisticsIntroduce.vue?vue&type=script&lang=js"
export * from "./LogisticsIntroduce.vue?vue&type=script&lang=js"
import style1 from "./LogisticsIntroduce.vue?vue&type=style&index=1&id=807d9718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_babel-core@6.26.3_css-loader@6.11.0_webpack@5.100_4xpmdqc3iaixeru4y6alscik5i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807d9718",
  null
  
)

export default component.exports